import NumberFormat from 'react-number-format';
import React, { ReactElement } from 'react';

import { TMoneyProperties } from './money.types';

export function Money({
    amount,
    isPennies = false,
    showPennies = false,
}: TMoneyProperties): ReactElement {
    const decimalScale = showPennies ? 2 : 0;
    let amountAsPounds = amount;

    if (isPennies) {
        amountAsPounds = showPennies
            ? Number((amount / 100).toFixed(2))
            : amount / 100;
    }

    return (
        <NumberFormat
            value={amountAsPounds}
            decimalScale={decimalScale}
            fixedDecimalScale
            thousandSeparator
            displayType="text"
            prefix="£"
        />
    );
}
